<template>
    <b-nav-item-dropdown
        class="dropdown-notification ml-25"
        menu-class="dropdown-menu-media"
        v-if="isVisible"
    >
        <template #button-content>
            DebugToolbar
        </template>

        <vue-perfect-scrollbar
            v-once
            :settings="perfectScrollbarSettings"
            class="scrollable-container media-list scroll-area"
            tagname="li"
        >
            <div v-if="isSubscriberVisible">
                <div class="media d-flex align-items-center">
                    <h4 class="font-weight-bolder mr-auto mb-0">
                        Subscriber settings
                    </h4>
                </div>
                <table class="table">
                    <tbody>
                        <tr>
                            <th>ID</th>
                            <td>{{ subscriber.id }}</td>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <td>{{ subscriber.name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="isSystemVisible">
                <div class="media d-flex align-items-center">
                    <h4 class="font-weight-bolder mr-auto mb-0">
                        System settings
                    </h4>
                </div>

                <div class="media d-flex align-items-center">
                    <h6 class="font-weight-bolder mr-auto mb-0">
                        DB Connection
                    </h6>
                </div>

                <div class="p-2">
                    <div>
                        DB
                        <b-badge>{{ dbConnection.database }}</b-badge>
                    </div>
                    <div>
                        Host
                        <b-badge>{{ dbConnection.host }}</b-badge>
                    </div>
                </div>
            </div>
        </vue-perfect-scrollbar>
    </b-nav-item-dropdown>
</template>

<script>
import {BNavItemDropdown, BBadge} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    components: {
        BNavItemDropdown, BBadge,
        VuePerfectScrollbar,
    },
    data() {
        return {
            perfectScrollbarSettings: {
                maxScrollbarLength: 60,
                wheelPropagation: false,
            },

            isSubscriberVisible: false,
            isSystemVisible: false,
            profile: null,

            subscriber: {
                id: null,
                name: null
            },
            dbConnection: {}
        }
    },
    methods: {
        populate(attributes) {
            this.isSystemVisible = false;
            this.isSubscriberVisible = false;

            if (attributes.subscriber) {
                this.subscriber.id = attributes.subscriber.id;
                this.subscriber.name = attributes.subscriber.name;
                this.isSubscriberVisible = true;
            }

            if (attributes.system) {
                this.dbConnection = attributes.system.connection;
                this.isSystemVisible = true;
            }
        }
    },
    created() {
        this.populate(this.$store.getters.profile.attributes);
    },
    computed: {
        isVisible() {
            return this.isSystemVisible || this.isSubscriberVisible;
        },
    },
    watch: {
        '$store.state.user.profile': function (profile) {
            this.populate(profile.attributes);
        }
    }
}
</script>
